import { Injectable } from '@angular/core';
import { CanActivateChild } from '@angular/router';

import { AuthGuard } from '../../../../core/services/auth/auth-guard.service';
import { UsuarioPerfil, usuarioPerfilAdministrador, usuarioPerfilAtendente } from '../../../usuario/usuario-perfil';


/** Acessos permitidos a consulta das adimplências dos títulos a receber */
export const acessosTituloReceberAdimplenciaConsulta: UsuarioPerfil[] = [usuarioPerfilAdministrador, usuarioPerfilAtendente];

@Injectable()
export class CanActivateTituloReceberAdimplenciaConsulta implements CanActivateChild {

    constructor(private authGuard: AuthGuard) { }

    canActivateChild(): boolean {
        return this.authGuard.canActivateAcesso(acessosTituloReceberAdimplenciaConsulta);
    }
}
